// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 13:39:31
import { CTacticalSituationBase_abstract } from './../abstract/SagaSchema/CTacticalSituationBase_abstract';
export class CTacticalSituationBase extends CTacticalSituationBase_abstract {}
